module.exports = __webpack_public_path__ + "static/media/9-item-c.6686ffe4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/9-item-c.jpg
// module id = 1217
// module chunks = 33